import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { JobActionsText, JobActionsValue } from "src/app/core/models/job";
import { JobsService } from "src/app/core/services/jobs.service";

@Component({
  selector: "app-job-confirmation-dialog",
  templateUrl: "./job-confirmation-dialog.component.html",
  styleUrls: ["./job-confirmation-dialog.component.scss"],
})
export class JobConfirmationDialogComponent implements OnInit {
  title: string;
  message: string;
  noBtnText: string;
  yesBtnText: string;
  actionValue: number = this.data.actionValue;
  deleteChecked: boolean = false;
  skipCloud: boolean = false;
  deleteWorkstoreData: boolean = false;
  deleteSyncstoreData: boolean = false;
  checkMultipleJobs: boolean = false;

  @ViewChild("deleteJobDataCheckbox") deleteJobDataCheckbox;

  constructor(
    public dialog: MatDialogRef<JobConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      depName: string;
      jobName: string;
      actionText: string;
      actionValue: number;
      title: string;
      message: string;
      noBtnText: string;
      yesBtnText: string;
      snackBarMessage?: string;
    },
    public jobService: JobsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    if(this.data.jobName.split(',').length > 1)
      this.checkMultipleJobs = true;
    this.message = this.data.message;
    this.noBtnText = this.data.noBtnText;
    this.yesBtnText = this.data.yesBtnText;
    if(this.data.snackBarMessage){
      this.snackBar.open(this.data.snackBarMessage,"OK",{
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    }
  }

  onCancel() {
    this.snackBar.dismiss();
    this.dialog.close(false);
  }

  onSubmit() {
    this.snackBar.dismiss();
    if (this.data.actionValue !== -1 && this.data.actionValue !== 51) {
      try {
        if (this.actionValue == 11) {
          if(this.checkMultipleJobs){

            this.jobService
            .deleteMultipleJobs(
              this.data.depName,
              this.data.jobName,
              String(this.deleteChecked),
              String(this.deleteWorkstoreData),
              String(this.deleteSyncstoreData),
            )
            .subscribe(() => {
              this.snackBar.open("Jobs deletion request sent successfully", "Close", {
                duration: 3000,
                horizontalPosition: "center",
                verticalPosition: "bottom",
              });
            });

            // This will open the notification offcanvas
            const notifcationButton = document.querySelector('.notificationBtn');
            if (notifcationButton) {
              (notifcationButton as HTMLElement).click();
            }

            setTimeout(()=>{
              // This will refresh the notification so that the latest notfication will be shown
              const refreshButton = document.querySelector('.manualRefreshNotifications');
              if (refreshButton) {
                (refreshButton as HTMLElement).click();
              }
            }, 1000);

          }
          else{

            this.jobService
            .deleteJob(
              this.data.depName,
              this.data.jobName,
              String(this.deleteChecked),
              String(this.deleteWorkstoreData),
              String(this.deleteSyncstoreData),
            )
            .subscribe(() => {
              this.snackBar.open("Job deleted successfully", "Close", {
                duration: 3000,
                horizontalPosition: "center",
                verticalPosition: "bottom",
              });
            });
            
          } // for single delete job

        } else if (
          this.actionValue == 9 ||
          this.actionValue == 10 ||
          this.actionValue == 12 ||
          this.actionValue == 13
        ) {
        } else {
          let actionValue = this.data.actionValue;
          let actionText = this.data.actionText;
          this.jobService
            .triggerAnActionForJob(
              this.data.depName,
              this.data.jobName,
              actionText,
              actionValue,
              "false",
              "",
              ""
            )
            .subscribe(() => {
              if (this.actionValue == 14) {
                this.snackBar.open("Job data deleted successfully", "Close", {
                  duration: 3000,
                  horizontalPosition: "center",
                  verticalPosition: "bottom",
                });
              }
            });
        }
      } catch (e) {}
    }
    if (this.data.actionValue == -1) {
      const returnObject = { skipCloud: this.skipCloud };
      this.dialog.close({ returnObject });
      return;
    }
    this.dialog.close(true);
  }
}
